import type {
  WidgetSettings,
  WidgetSettingsUpdateInput,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const widgetSettingsApi = {
  get(chatbotId: string) {
    return request<WidgetSettings>(`/admin/widget-settings/${chatbotId}`);
  },
  update(chatbotId: string, input: WidgetSettingsUpdateInput) {
    return request<WidgetSettings>(`/admin/widget-settings/${chatbotId}`, {
      method: "PATCH",
      body: input,
    });
  },
};
